import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76a54eea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex_betwwen" }
const _hoisted_2 = { class: "flex_item" }
const _hoisted_3 = { class: "cache_operate" }
const _hoisted_4 = { class: "cache_operate_main" }
const _hoisted_5 = { class: "list_file_class text_box" }
const _hoisted_6 = { class: "highlight" }
const _hoisted_7 = { class: "list_file_class text_box" }
const _hoisted_8 = { class: "highlight" }
const _hoisted_9 = { class: "cache_operate_right" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "content_square" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 4,
  class: "mod_pagin"
}
const _hoisted_14 = { class: "page_total" }

import { ref, withDefaults, reactive, computed, inject } from 'vue';
import { DatePicker, Input, Pagination, Modal, message } from 'ant-design-vue';
import CDelModal from '@/components/CDelModal.vue';

import LiveItemSquare from '@/components/liveItem/LiveItemSquare.vue';
import LiveItemBar from '@/components/liveItem/LiveItemBar.vue';
import ModalSubAuto from './place/ModalSubAuto.vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import moment, { Moment } from 'moment';
import type { Imodal } from './place/Place.vue';
import { useStore } from 'vuex';
import type { RootLive, SearchLiveClass } from '@/store/modules/live/types';
import AppLink from '@/components/AppLink.vue';
import http from '@/api/live';
import { emptyDataSec } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce';
import { RootModal } from '@/components/CDelModal.vue';
import { getCertificationView } from '@/plugins/cookie';
import CLoading from '@/components/CLoading.vue';
import { ClientSize } from '../home/types';

// 子账号授权
export interface Option {
  label: string;
  value: string;
}
export interface SubAcForm {
  childList: Option[];
}
interface ChildInfo {
  id: number;
  name: string;
  created_at: string;
}

interface IProps {
  viewSwitch?: boolean;
}
interface Options {
  label: string;
  value: number | '';
}
interface Condition {
  fileClass: Options[];
  status: Options[];
  mode: Options[];
  pushType: Options[];
  tofileClass: Options[];
  subAdmin: Options[];
}
interface LiveSearch extends Partial<SearchLiveClass> {
  liveDate: Moment[];
}


import dayjs, { Dayjs } from 'dayjs';
import { dateFormats } from '@/utils/format/date';
export interface ILives {
  id: string;
  name: string;
  datetime: string;
  duration: number;
  liveType: string;
  liveCount: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    viewSwitch: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { viewSwitch: boolean };

const store = useStore();
const aInputSearch = Input.Search;
const aPagination = Pagination;
const aRangePicker = DatePicker.RangePicker;
const aModal = Modal;
const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  明天: [moment().startOf('day').subtract(-1, 'day'), moment().endOf('day').subtract(-1, 'day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};

// 筛选标记
const selectKeys = ref({});
const isShow = ref(false);
const getSelectIds = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
    }
  });
  return selectArr.join(',');
});
const getSelected = computed(() => Boolean(!getSelectIds.value));
const choice = ref(false);
const choice_all = ref(false);
const isChecked = computed(() => {
  return choice.value || choice_all.value;
});
const changeItemMarkAll = () => {
  if (choice_all.value === true) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = true;
    });
  } else {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeSwitch = () => {
  if (choice.value === false) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeItemMark = (item: RootLive) => {
  selectKeys.value[item.id] = !selectKeys.value[item.id];
};

// 获取列表筛选项
const condition = reactive<Condition>({
  fileClass: [
    {
      label: '全部分类',
      value: '',
    },
  ],
  status: [
    {
      label: '全部直播间',
      value: '',
    },
  ],
  mode: [
    {
      label: '全部直播间',
      value: '',
    },
  ],
  pushType: [
    {
      label: '全部直播间',
      value: '',
    },
  ],
  subAdmin: [],
  tofileClass: [],
});
// const subAccount = reactive([
//   // {
//   //   label: '全部',
//   //   value: 0,
//   // },
//   // {
//   //   label: '子账号直播间',
//   //   value: 1,
//   // },
// ]);
const getCondition = () => {
  http.getCondition().then((res) => {
    const resData = res.data.data;
    const stArr: Options[] = resData.status
      ? resData.status.map((e: any) => ({
          label: e.name,
          value: e.ide,
        }))
      : [];
    condition.status.push(...stArr);

    const mArr: Options[] = resData.mode
      ? resData.mode.map((e: any) => ({
          label: e.name,
          value: e.ide,
        }))
      : [];
    condition.mode.push(...mArr);

    const pTArr: Options[] = resData.push_type
      ? resData.push_type.map((e: any) => ({
          label: e.name,
          value: e.ide,
        }))
      : [];
    condition.pushType.push(...pTArr);
    const sAArr: Options[] = resData.sub_admin
      ? resData.sub_admin.map((e: any) => ({
          label: e.name,
          value: e.ide,
        }))
      : [];
    condition.subAdmin.push(...sAArr);
  });
  http.getFileClassList().then((res) => {
    const resData = res.data.data;
    const cArr: Options[] = resData
      ? resData.map((e: any) => ({
          label: e.name,
          value: e.ide,
        }))
      : [];
    condition.tofileClass = cArr;
    condition.fileClass.push(...cArr);
  });
};
getCondition();

//  排序切换
const orderStatusArr = [2, 1]; // 2 正序 | 1 倒叙
const orderOptions = [
  {
    title: '直播状态',
    option: 'status_order',
  },
  // {
  //   title: '创建时间',
  //   option: 'create_at_order',
  // },
  {
    title: '开播时间',
    option: 'start_at_order',
  },
];

const orderKey = ref(0); //
const orderStatus = ref(true); // 正序 倒序
const orderStatusIcon = computed(() => (orderStatus.value ? 'list_sort' : 'list_post_sort'));
const changeOrder = (key: number) => {
  if (orderKey.value === key) {
    orderStatus.value = !orderStatus.value;
  }
  orderKey.value = key;
  getLiveList({ current: 1 });
};

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});

const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const removeLiveData = () => {
  delModal.loading = true;
  store
    .dispatch('live/delLiveData', getSelectIds.value)
    .then(() => {
      message.success('操作成功');
      getLiveList();
    })
    .finally(() => {
      delModal.loading = false;
      delModal.visible = false;
    });
};

const subFrom = reactive<SubAcForm>({
  childList: [],
});
const childList = ref<Option[]>([]);
const subAutoModal = reactive<Imodal>({
  title: '临时账号授权',
  visible: false,
  loading: false,
});
const openSubAutoModal = useDebounce(async () => {
  if (!subAutoModal.visible) {
    const res = (await http.getChildList()).data.data.data;
    childList.value = res.map((e: ChildInfo) => ({
      label: e.name,
      value: e.id,
    }));
  }
  subAutoModal.visible = !subAutoModal.visible;
});
const setSubAuto = useDebounce(() => {
  subAutoModal.loading = true;
  const reqData = {
    studio_id: getSelectIds.value,
    child_accounts_ids: subFrom.childList.join(','),
  };
  http
    .addStudioChild(reqData)
    .then((res) => {
      message.success(res.data.message);
      subFrom.childList = [];
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      subAutoModal.loading = false;
      // subAutoModal.visible = false;
    });
});
// 列表
const liveTypeForm = ref<Options[]>([]);
const moveLiveType = async () => {
  try {
    const formData = {
      old_file_class_id: queryForm.file_class,
      file_class_id: liveTypeForm.value,
      studio_str: getSelectIds.value,
    };
    const res = await http.studioMovesFolder(formData);
    message.success(res.data.message);
    liveTypeForm.value = [];
    getLiveList();
  } catch (err: any) {
    message.error(err.data.error);
  }
};

const liveList = computed(() => store.state.live.liveList);

const liveCount = ref(0); //正在直播数量
const liveStudioCount = ref(0); //累计直播总数

const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
  options: ['20', '24', '36', '48', '60'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});

const queryForm = reactive<any>({
  keywords: '',
  liveDate: [],
  sub_studio: 0,
});

/**
 * 豆腐块获取数量计算
 * 三级菜单使用自定义宽度 且 最小宽对应当前组件样式宽度
 */
const baseSize = inject('ClientSize') as ClientSize;
const getItemCount = () => {
  const wrapWidth = baseSize.width - baseSize.menuSize - 71;
  let itemWidth = 0;
  let baseNum = 3;
  const gap = 16; // 间距
  let testkey = 0;
  let lastItemWidth = 0;
  let lastBaseNum = 0;
  do {
    lastItemWidth = itemWidth;
    lastBaseNum = baseNum;
    const countNum = (((wrapWidth - (baseNum - 1) * gap) / baseNum) * 100).toString();
    itemWidth = parseFloat((parseInt(countNum) / 100).toFixed(2));
    baseNum = baseNum + 1;
    testkey++;
  } while (itemWidth >= baseSize.minWidth);
  const rowCount = lastBaseNum - 1;
  const itemHeight = parseFloat((((lastItemWidth - 2) * 5625) / 10000 + 80).toFixed(2));
  let columnCount = Math.ceil((baseSize.height - 400) / itemHeight);
  let resCount = rowCount * columnCount;
  while (resCount < 9) {
    columnCount += 1;
    resCount = rowCount * columnCount;
  }
  for (let i = 0; i < 5; i++) {
    pageConfig.options[i] = (resCount * (i + 1)).toString();
  }
  return resCount;
};
pageConfig.pageSize = getItemCount();
const showLoading = ref(false);

const getLiveList = useDebounce(async (pageData?: { current: number }) => {
  showLoading.value = false;
  try {
    const { current, pageSize } = pageConfig;
    const search = {
      page: pageData?.current ?? current,
      page_num: pageSize,
      [orderOptions[orderKey.value].option]: orderStatusArr[Number(orderStatus.value)],
      ...queryForm,
      // start_at: queryForm.liveDate[0] ? new Date(queryForm.liveDate[0]) : queryForm.liveDate[0],
      // end_at: queryForm.liveDate[1] ? new Date(queryForm.liveDate[1]) : queryForm.liveDate[1],
      // keyword: queryForm.keywords,
      // sub_studio:queryForm.sub_studio
    };
    const { current_page, total, data, live_count, live_studio_count } = await store.dispatch('live/getLiveList', search);
    choice_all.value = false;
    choice.value = false;
    showLoading.value = true;
    selectKeys.value = {};
    data.map((e: RootLive) => {
      selectKeys.value[e.id] = false;
    });
    liveCount.value = live_count;
    liveStudioCount.value = live_studio_count;
    pageConfig.current = current_page;
    pageConfig.totalSize = total;
  } catch (err: any) {
    console.error(err.data.error);
    showLoading.value = true;
  }
});
getLiveList();
const handleDateSelection = () => {
  if (queryForm.liveDate.length > 0) {
    // 获取第一个选中的日期作为开始时间，设置为 00:00
    const startDate = moment(queryForm.liveDate[0]).startOf('day');
    // 获取最后一个选中的日期作为结束时间，设置为 23:59
    const endDate = moment(queryForm.liveDate[queryForm.liveDate.length - 1]).endOf('day');
    // 更新 queryForm 中的 liveDate
    queryForm.liveDate = [startDate, endDate];
  } else {
    queryForm.liveDate = [];
  }
};
const onChangePicker = (data:any) => {
  getLiveList({ current: 1 });
};
const onChangeList = () => {
  getLiveList({ current: 1 });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_select, {
          class: "mod_select",
          value: queryForm.file_class,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.file_class) = $event)),
          onChange: onChangeList,
          placeholder: "直播分类",
          options: condition.fileClass
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options"]),
        _createVNode(_component_a_select, {
          class: "mod_select",
          value: queryForm.status,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.status) = $event)),
          placeholder: "直播状态",
          onChange: onChangeList,
          options: condition.status
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options"]),
        _createVNode(_component_a_select, {
          class: "mod_select",
          value: queryForm.mode,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.mode) = $event)),
          placeholder: "直播模式",
          options: condition.mode,
          onChange: onChangeList
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options"]),
        _createVNode(_component_a_select, {
          class: "mod_select",
          value: queryForm.push_type,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.push_type) = $event)),
          placeholder: "直播延迟",
          options: condition.pushType,
          onChange: onChangeList
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options"]),
        _createVNode(_unref(aRangePicker), {
          class: "mod_range_picker",
          value: queryForm.liveDate,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.liveDate) = $event)),
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          ranges: ranges,
          onOk: onChangeList,
          onBlur: onChangePicker,
          onChange: _cache[5] || (_cache[5] = ($event: any) => (handleDateSelection()))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_unref(aInputSearch), {
        class: "mod_range_picker_search",
        value: queryForm.keywords,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.keywords) = $event)),
        placeholder: "请输入关键字",
        onSearch: onChangeList
      }, {
        enterButton: _withCtx(() => [
          _createVNode(_unref(SearchOutlined))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderOptions, (item, index) => {
          return _createVNode(_component_a_button, {
            key: item.option,
            class: _normalizeClass(["mod_btn mod_btn_primary order", { actived: orderKey.value === index }]),
            onClick: ($event: any) => (changeOrder(index))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_svg_icon, {
                class: "mod_btn_icon",
                "icon-class": _unref(orderStatusIcon)
              }, null, 8, ["icon-class"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"])
        }), 64)),
        _withDirectives(_createVNode(_component_a_select, {
          class: "mod_select selected",
          value: queryForm.sub_studio,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.sub_studio) = $event)),
          onChange: _cache[8] || (_cache[8] = ($event: any) => (onChangeList())),
          placeholder: "全部",
          options: condition.subAdmin
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options"]), [
          [_vShow, _unref(getCertificationView)() == 1]
        ]),
        _createVNode(_component_a_button, {
          class: "mod_btn",
          disabled: _unref(getSelected),
          onClick: _unref(openSubAutoModal)
        }, {
          default: _withCtx(() => [
            _createTextVNode("临时账号授权")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_a_select, {
          class: "mod_select list_file_class",
          value: liveTypeForm.value,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((liveTypeForm).value = $event)),
          placeholder: "移至分类",
          options: condition.tofileClass,
          disabled: _unref(getSelected),
          onChange: _cache[10] || (_cache[10] = ($event: any) => (moveLiveType()))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options", "disabled"]),
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode("直播间总数："),
          _createElementVNode("span", _hoisted_6, _toDisplayString(liveStudioCount.value), 1)
        ]),
        _createElementVNode("span", _hoisted_7, [
          _createTextVNode("正在推流中："),
          _createElementVNode("span", _hoisted_8, _toDisplayString(liveCount.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_checkbox, {
          class: "checkbox",
          checked: choice.value,
          "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((choice).value = $event)),
          onChange: _cache[12] || (_cache[12] = ($event: any) => (changeSwitch()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("选择")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_checkbox, {
          class: "checkbox",
          checked: choice_all.value,
          "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((choice_all).value = $event)),
          onChange: _cache[14] || (_cache[14] = ($event: any) => (changeItemMarkAll()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("全选")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_button, {
          class: "mod_btn",
          type: "link",
          danger: "",
          disabled: _unref(getSelected),
          onClick: _cache[15] || (_cache[15] = ($event: any) => (openDelModal()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_btn_icon",
              "icon-class": "del"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 删除 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    (props.viewSwitch)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(liveList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                _createVNode(AppLink, {
                  to: `/live_set/${item.id}/broad_cast_control`,
                  disable: _unref(isChecked)
                }, {
                  default: _withCtx(() => [
                    _createVNode(LiveItemSquare, {
                      "data-source": item,
                      choice: _unref(isChecked),
                      selected: selectKeys.value[item.id],
                      "onSelect:changeItemMark": changeItemMark
                    }, null, 8, ["data-source", "choice", "selected"])
                  ]),
                  _: 2
                }, 1032, ["to", "disable"])
              ]))
            }), 128))
          ])
        ], 512)), [
          [_vShow, showLoading.value]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_a_row, { gutter: [24, 24] }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(liveList), (item) => {
                return (_openBlock(), _createBlock(_component_a_col, {
                  key: item.id,
                  class: "gutter-row",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(AppLink, {
                      to: `/live_set/${item.id}/broad_cast_control`,
                      disable: _unref(isChecked)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(LiveItemBar, {
                          "data-source": item,
                          choice: _unref(isChecked),
                          selected: selectKeys.value[item.id],
                          "onSelect:changeItemMark": changeItemMark,
                          QRCode: !_unref(isChecked)
                        }, null, 8, ["data-source", "choice", "selected", "QRCode"])
                      ]),
                      _: 2
                    }, 1032, ["to", "disable"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ], 512)), [
          [_vShow, showLoading.value]
        ]),
    (!showLoading.value)
      ? (_openBlock(), _createBlock(CLoading, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(liveList).length === 0 && showLoading.value)
      ? (_openBlock(), _createBlock(_component_a_empty, {
          key: 3,
          class: "empty_wrap",
          image: _unref(emptyDataSec),
          description: "页面暂无数据信息~"
        }, null, 8, ["image"]))
      : _createCommentVNode("", true),
    (_unref(liveList).length !== 0 && showLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_unref(aPagination), {
            "show-quick-jumper": "",
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[16] || (_cache[16] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[17] || (_cache[17] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-size-changer": "",
            onChange: _unref(getLiveList),
            onShowSizeChange: _unref(getLiveList)
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"]),
          _createElementVNode("div", _hoisted_14, "共 " + _toDisplayString(pageConfig.totalSize) + " 条", 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      close: openDelModal,
      ok: removeLiveData
    }, null, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: subAutoModal.visible,
      "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((subAutoModal.visible) = $event)),
      title: subAutoModal.title,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(openSubAutoModal)()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          loading: subAutoModal.loading,
          onClick: _unref(setSubAuto)
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(ModalSubAuto, {
          modelValue: subFrom,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((subFrom) = $event)),
          "source-data": childList.value
        }, null, 8, ["modelValue", "source-data"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})